export default {
  title: {
    en: 'Tired of fragrances?<br class="mobile" /> Try other products!',
  },

  handCreams: {
    en: 'The hand creams<br class="tablet" /> collection',
  },
  personalCare: {
    en: 'The bath & body<br class="tablet" /> collection',
  },
  scentedCandles: {
    en: 'The scented candles<br class="tablet" /> collection',
  },
  bodyLip: {
    en: 'The lip balms<br class="tablet" /> collection',
  },

  close: {
    en: 'Close',
  },
  learnMore: {
    en: 'Learn more',
  },
  cancelSubscription: {
    en: 'Cancel my subscription',
  },
}
